import { ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import { createContext, default as React } from "react";
import { Cookies } from "react-cookie";
import ContentsStyles from "./assets/js/contents";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import { darkTheme, lightTheme } from "Theme";
import App from "./App";
import GlobalStyles from "./assets/js/global";
import rootReducer from "./redux/reducers";
import rootSaga from "./redux/sagas";
import reportWebVitals from "./reportWebVitals";
import debounce from "lodash/debounce";
import { formatMuiErrorMessage } from "@mui/utils";
import jwt_decode from "jwt-decode";
import { setCookiesSync } from "assets/js/common";
import { setAppData } from "assets/js/apphandle";

const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware)),
);
const cookies = new Cookies();

let cookieExpires = new Date();
cookieExpires.setDate(cookieExpires.getDate() + 180);

sagaMiddleware.run(rootSaga);

axios.defaults.baseURL = "https://mcaapp.megamart.com";
//axios.defaults.baseURL = "https://devapp.megamart.com";
// axios.defaults.baseURL = "http://localhost:3001";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

axios.interceptors.request.use(async (config) => {
  config.headers.Authorization = cookies.get("X-AUTH-TOKEN") || "";
  return config;
});

const logout = (returnFunc) => {
  if (window.Android) {
    window.Android.logout(returnFunc);
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ios
  ) {
    // Call iOS interface
    var message = {
      command: "logout",
      func: returnFunc,
    };
    window.webkit.messageHandlers.ios.postMessage(message);
  } else {
    cookies.remove("favInfo", { path: "/" });
    cookies.remove("X-AUTH-TOKEN", { path: "/" });
    cookies.remove("X-REFRESH-TOKEN", { path: "/" });
    cookies.remove("autoToken", { path: "/" });
    window.location.href = "/";
  }
};

const autoLogin = async (error) => {
  let cookieExpires = new Date();
  cookieExpires.setDate(cookieExpires.getDate() + 180);

  let checked = cookies.get("checked") || "";
  let autoToken = cookies.get("autoToken") || "";
  if (checked == "true" && autoToken) {
    let form = {
      grantType: "auto",
      username: autoToken,
    };
    axios
      .post("/api/auth/token", form)
      .then((res) => {
        let newToken = res.data.data;
        const myDecodedToken = jwt_decode(newToken.accessToken);
        axios.defaults.headers.Authorization = `${newToken.tokenType} ${newToken.accessToken}`;

        setCookiesSync(
          "X-AUTH-TOKEN",
          `${newToken.tokenType} ${newToken.accessToken}`,
        );

        // cookies.set(
        //   "X-AUTH-TOKEN",
        //   `${newToken.tokenType} ${newToken.accessToken}`,
        //   {
        //     path: "/",
        //     expires: cookieExpires,
        //   }
        // );
        setCookiesSync("X-REFRESH-TOKEN", newToken.refreshToken);
        // cookies.set("X-REFRESH-TOKEN", `${newToken.refreshToken}`, {
        //   path: "/",
        //   expires: cookieExpires,
        // });
        setCookiesSync("no", myDecodedToken.no);
        // cookies.set("no", myDecodedToken.no, {
        //   path: "/",
        //   expires: cookieExpires,
        // });
        setCookiesSync("checked", checked);
        // cookies.set("checked", checked, {
        //   path: "/",
        //   expires: cookieExpires,
        // });

        let data = "";

        //app
        axios.get("/api/mb/member/my-info").then((res) => {
          data = res.data.data;
          setCookiesSync("favInfo", {
            defaultTp: data.member.mainTp || 1, //설정에서 세팅하는 tp
            visibleTp: data.member.mainTp || 1, //메인 화면에서 변경시키는 tp
            favMk: data.member.favMk,
            favMt: data.member.favMt,
          });
          // cookies.set(
          //   "favInfo",
          //   {
          //     defaultTp: data.member.mainTp || 1, //설정에서 세팅하는 tp
          //     visibleTp: data.member.mainTp || 1, //메인 화면에서 변경시키는 tp
          //     favMk: data.member.favMk,
          //     favMt: data.member.favMt,
          //   },
          //   {
          //     path: "/",
          //     expires: cookieExpires,
          //   }
          // );
        });

        window.loginComplete2 = function (authKey, pushUrl) {
          location.reload();
        };

        const no = cookies.get("no");
        if (window.Android) {
          window.Android.login(
            no,
            data.tag,
            data.member.mktPushYn,
            "loginComplete2",
          );
        } else if (
          window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.ios
        ) {
          // Call iOS interface
          var message = {
            command: "login",
            id: no,
            tag: data.tag,
            adYn: data.member.mktPushYn,
            func: "loginComplete2",
          };
          window.webkit.messageHandlers.ios.postMessage(message);
        }
        location.reload();
      })
      .catch((err) => {
        window.logoutReturnFunc2 = () => {
          cookies.remove("favInfo", { path: "/" });
          cookies.remove("X-AUTH-TOKEN", { path: "/" });
          cookies.remove("X-REFRESH-TOKEN", { path: "/" });
          cookies.remove("autoToken", { path: "/" });
          setAppData();
          window.location.href = "/";
        };
        logout("logoutReturnFunc2");
      });
  } else {
    window.logoutReturnFunc3 = () => {
      cookies.remove("favInfo", { path: "/" });
      cookies.remove("X-AUTH-TOKEN", { path: "/" });
      cookies.remove("X-REFRESH-TOKEN", { path: "/" });
      cookies.remove("autoToken", { path: "/" });
      setAppData();
      window.location.href = "/";
    };
    logout("logoutReturnFunc3");
  }
};

const refreshTokenAPI = async () => {
  return new Promise((resolve) => {
    axios
      .post(`/api/auth/token`, {
        grantType: "refresh_token",
        refreshToken: cookies.get("X-REFRESH-TOKEN"),
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        autoLogin();
      });
  });
};

const refreshTokenAPIScheduler = debounce(
  refreshTokenAPI,
  200, // 200ms 화면전환에 의한 Component요청이 생길 수있는 최대시간을 적어주면 좋을 것 같다.
  { leading: true, trailing: false }, // Option 설정 중요
);

axios.interceptors.response.use(
  (config) => {
    console.log("config: ", config);
    return config;
  },
  async (error) => {
    console.log("error: ==================================== ", error);
    console.log(
      "error.response.data.code: ",
      error.response.status,
      error.response.data.code,
    );

    if (error.response.status == 401) {
      const newToken = await refreshTokenAPIScheduler();

      setCookiesSync(
        "X-AUTH-TOKEN",
        `${newToken.data.tokenType} ${newToken.data.accessToken}`,
      );
      // cookies.set(
      //   "X-AUTH-TOKEN",
      //   `${newToken.data.tokenType} ${newToken.data.accessToken}`,
      //   {
      //     path: "/",
      //     expires: cookieExpires,
      //   }
      // );
      setCookiesSync("X-REFRESH-TOKEN", newToken.data.refreshToken);
      // cookies.set("X-REFRESH-TOKEN", `${newToken.data.refreshToken}`, {
      //   path: "/",
      //   expires: cookieExpires,
      // });

      if (newToken.data.autoToken) {
        setCookiesSync("autoToken", newToken.data.autoToken);
        //   cookies.set("autoToken", `${newToken.data.autoToken}`, {
        //     path: "/",
        //     expires: cookieExpires,
        //   });
      }

      return axios(error.config);
    }
    //  else if (error.response.data.code == "TK001") {
    //   await autoLogin(error);
    // }

    return Promise.reject(error);
  },
);

export const rootContext = createContext();
const apiKey = "dj0t0m0cbm8a0bqhu9gyez5hnm9mr8fuq66d3nvzcc5pahmr";
function render() {
  ReactDOM.render(
    <Provider store={store}>
      <ThemeProvider theme={lightTheme}>
        <ContentsStyles />
        <GlobalStyles />
        <rootContext.Provider value={{ apiKey }}>
          <App />
        </rootContext.Provider>
      </ThemeProvider>
    </Provider>,
    document.getElementById("root"),
  );
}

render();
store.subscribe(render);
reportWebVitals();
